module.exports = __webpack_public_path__ + "static/assets/4b701263121b18b9cceb5402bb6f9321.png";